import { render, staticRenderFns } from "./scoreTable.vue?vue&type=template&id=24db5f4a&"
import script from "./scoreTable.vue?vue&type=script&lang=js&"
export * from "./scoreTable.vue?vue&type=script&lang=js&"
import style0 from "./scoreTable.vue?vue&type=style&index=0&id=24db5f4a&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports